import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const sliderVariation = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.sliderInit();
			this.checkTruncation();
		},

		cacheDOM: function() {
			this.$slider = $('.js-slider-variation');
			this.$prevArrow = $('.js-slider-variation-prev');
			this.$nextArrow = $('.js-slider-variation-next');
		},

		bindEvents: function() {
			this.$slider.on('click', '.js-slider-variation-toggle', this.handleToggle.bind(this));
			$(window).on('load', this.checkTruncation.bind(this));

			let resizeTimeout;
			$(window).on('resize', () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(this.checkTruncation.bind(this), 200);
			});
		},

		checkTruncation: function() {
			this.$slider.find('.js-slider-variation-content').each(function() {
				const $content = $(this);
				const $toggle = $content.siblings('.js-slider-variation-toggle');
				const $slide = $content.closest('.js-slider-variation-slide');

				if (!$toggle.length || $slide.hasClass('is-expanded')) {
					return;
				}

				const collapsedHeight = this.clientHeight;
				const fullHeight = this.scrollHeight;

				$content.data('collapsed-height', collapsedHeight);
				$content.data('full-height', fullHeight);

				const isTruncated = fullHeight - 1 > collapsedHeight;
				$toggle.toggleClass('is-hidden', !isTruncated);
			});
		},

		handleToggle: function(e) {
			e.preventDefault();

			const $toggle = $(e.currentTarget);
			const $slide = $toggle.closest('.js-slider-variation-slide');
			const $content = $slide.find('.js-slider-variation-content');
			const isExpanding = !$slide.hasClass('is-expanded');
			const collapsedHeight = $content.data('collapsed-height');
			const fullHeight = $content.data('full-height');

			$toggle.attr('aria-expanded', isExpanding);
			$content.css('max-height', isExpanding ? collapsedHeight : fullHeight);

			if (isExpanding) {
				$slide.addClass('is-expanded');
			}

			requestAnimationFrame(() => {
				$content.css('max-height', isExpanding ? fullHeight : collapsedHeight);
			});

			$content.one('transitionend', (event) => {
				if (event.originalEvent.propertyName !== 'max-height') {
					return;
				}

				if (!isExpanding) {
					$slide.removeClass('is-expanded');
				}

				$content.css('max-height', '');
				this.$slider.slick('setPosition');
			});
		},

		sliderInit: function() {
			const sliderConfig = {
				slidesToShow: 3.1,
				slidesToScroll: 1,
				infinite: false,
				autoplay: false,
				arrows: true,
				prevArrow: this.$prevArrow,
				nextArrow: this.$nextArrow,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 2.4
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1.4
						}
					},
					{
						breakpoint: 400,
						settings: {
							slidesToShow: 1.2
						}
					}
				]
			};

			sliders.initializeSlider('.js-slider-variation', sliderConfig);
		},

	};

	sliderVariation.init();

});
